import { WrapView, Badge } from '@planningcenter/tapestry-react';
import React from 'react';
import { Section } from './section.js';

const AppGroups = {
    Services: ({ groups }) => {
        const teams = ["Team", "PlanTeam"].reduce((acc, type) => (groups[type] ? [...acc, ...groups[type]] : acc), []);
        return (React.createElement(Section, { title: "Teams" },
            React.createElement(WrapView, { spacing: 1 }, teams.map((team) => (React.createElement(Badge, { key: team.source_identifier, size: "sm" }, team.name))))));
    },
};
const Groups = ({ groups }) => {
    return (React.createElement(React.Fragment, null, Object.entries(groups).reduce((acc, [appName, appGroups]) => {
        const Component = AppGroups[appName];
        if (!Component)
            return acc;
        return [...acc, React.createElement(Component, { key: appName, groups: appGroups })];
    }, [])));
};

export { Groups };
//# sourceMappingURL=groups.js.map
